import { registerTimeAssignment } from "@/api/timeAssignments/registerTimeAssignment"
import { useMutation } from "@tanstack/react-query"

export const useRegisterTimeAssignment = () => {

  return useMutation({
    mutationKey: ["registerTimeAssignment"],
    mutationFn: registerTimeAssignment
  })
}